// extracted by mini-css-extract-plugin
export default {"container":"Navigator_container__Zcx2W","splitter":"Navigator_splitter__r0Htl","link":"Navigator_link__cDUOu"};